import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";

export default function Layout() {
  return (
    <div className="flex min-h-screen bg-[#F8FAFC]">
      <Sidebar />
      <main className="flex-1 ml-[240px] p-8 animate-fade-in" data-testid="main-content">
        <Outlet />
      </main>
    </div>
  );
}
